module.exports = __webpack_public_path__ + "img/ai-icon.1af6d8a8.png";